import React from "react";
import { Modal, Button, ButtonToolbar } from "react-bootstrap";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SimpleModal.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class SimpleModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.shownByDefault
        };
    }
    toggle() {
        this.setState({ isOpen: !this.state.isOpen });
    }
    renderAction() {
        const { action, actionText } = this.props;
        if (action === "link") {
            return React.createElement("a", { className: styles.noWrapText, onClick: () => this.toggle() }, actionText);
        }
        else {
            return (React.createElement(Button, { onClick: () => this.toggle() }, actionText));
        }
    }
    render() {
        const { isOpen } = this.state;
        const { modalTitle, action, actionText } = this.props;
        return (React.createElement("div", null,
            React.createElement(Modal, { bsSize: "lg", onHide: () => this.toggle(), show: isOpen },
                React.createElement(Modal.Header, { closeButton: true },
                    React.createElement(Modal.Title, null, modalTitle)),
                React.createElement(Modal.Body, null, this.props.children),
                React.createElement(Modal.Footer, null,
                    React.createElement(ButtonToolbar, { className: styles.buttonContainer },
                        React.createElement(Button, { onClick: () => this.toggle() }, "Close")))),
            this.renderAction()));
    }
}
